'use client'

import { useElementVisible } from '@hooks/useElementVisible'
import { HeroMock } from '@components/AboutUs/AboutUsMock'
import { VIDEO_NO_SUPPORT } from '@constants/aboutUs'
import styles from './Hero.module.scss'
import { Values } from './Values'

const Hero = () => {
  const missionText = useElementVisible({ threshold: 0.2 })
  const headingSection = useElementVisible({ threshold: 0.8, everyInteraction: true })
  if (!HeroMock) return null
  return (
    <div className={styles.main}>
      <div className={styles.topSection} ref={headingSection.ref}>
        {HeroMock?.backgroundVideoDesktopSrc && (
          <>
            <video autoPlay muted playsInline className={`${styles.videoBackground} ${styles.videoBackgroundMobile}`}>
              <source src={HeroMock.backgroundVideoMobileSrc} type="video/mp4" />
              {VIDEO_NO_SUPPORT}
            </video>
            <video autoPlay muted playsInline className={`${styles.videoBackground} ${styles.videoBackgroundDesktop}`}>
              <source src={HeroMock.backgroundVideoDesktopSrc} type="video/mp4" />
              {VIDEO_NO_SUPPORT}
            </video>
          </>
        )}
        <div className={`${styles.heading} ${headingSection.isVisible ? styles.visible : ''}`}>{HeroMock?.heading}</div>
        <div className={`${styles.subHeading} ${missionText.isVisible ? styles.visible : ''}`} ref={missionText.ref}>
          {HeroMock?.subHeading}
        </div>
      </div>

      <div className={styles.bottomSection}>
        <div className={styles.flexible}>
          {HeroMock?.features?.map((feature, idx) => <Values feature={feature} index={idx} />)}
        </div>
      </div>
    </div>
  )
}

export default Hero
